import { render } from "./index.vue?vue&type=template&id=2783fbb2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/activity-center/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2783fbb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2783fbb2', __exports__)) {
    console.log('reload')
    api.reload('2783fbb2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=2783fbb2", () => {
    console.log('re-render')
    api.rerender('2783fbb2', render)
  })

}


export default __exports__